import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { DatePickerProps } from "element-plus";
import { useField } from "vee-validate";
import { onMounted, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    defaultValue: null,
    type: null,
    classPicker: null,
    classParent: null,
    label: null,
    format: null,
    name: null,
    smallLabel: { type: Boolean },
    isRequired: { type: Boolean },
    valueChange: null,
    placeholder: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
	defaultValue?: Date | undefined;
	type:
		| "year"
		| "month"
		| "date"
		| "dates"
		| "week"
		| "datetime"
		| "datetimerange"
		| "daterange"
		| "monthrange";
	classPicker?: string;
	classParent?: string;
	label: string;
	format: string;
	name: string;
	smallLabel?: boolean;
	isRequired?: boolean;
	valueChange?: number;
	placeholder?: string;
	size?: "sm" | "lg" | "md";
}



// Data
const { value: inputValue, errorMessage } = useField<Date>(
	props.name,
	undefined,
	{
		initialValue: props.defaultValue,
	}
);

watch(
	() => props.valueChange,
	() => {
		if (props.defaultValue) inputValue.value = props.defaultValue;
	}
);

onMounted(() => {
	if (props.defaultValue) inputValue.value = new Date(props.defaultValue);
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.classParent ? __props.classParent : 'form-group px-1')
  }, [
    _createElementVNode("div", null, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: _normalizeClass({
					'text-danger': _unref(errorMessage),
					'text-muted': !_unref(errorMessage),
				})
          }, [
            (__props.smallLabel)
              ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(__props.label), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.label), 1)),
            (__props.isRequired)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_date_picker, {
      type: __props.type,
      name: __props.name,
      class: _normalizeClass(__props.classPicker),
      format: __props.format,
      placeholder: __props.placeholder,
      size: __props.size === 'sm' ? 'small' : __props.size === 'lg' ? 'large' : 'default',
      "model-value": _unref(inputValue),
      "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null))
    }, null, 8, ["type", "name", "class", "format", "placeholder", "size", "model-value"]),
    _withDirectives(_createElementVNode("div", {
      class: "text-danger invalid-feedback",
      style: {"display":"block"}
    }, _toDisplayString(_unref(errorMessage)), 513), [
      [_vShow, _unref(errorMessage)]
    ])
  ], 2))
}
}

})